import React from "react";

const Sidebar = ({ activeSection, onSelectSection, menuItems = [] }) => {
  return (
    <aside
      data-internal-sidebar="true"
      className="w-full shrink-0 self-start rounded-3xl bg-white p-5 shadow-[0_10px_30px_rgba(0,0,0,0.08)] lg:w-[280px]"
    >
      {menuItems.map((item) => {
        const isActive = activeSection === item.id;

        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onSelectSection(item.id)}
            className={`mb-2.5 flex w-full items-center gap-2 rounded-[14px] border-[1.5px] px-4 py-2 text-left font-sans text-[15px] font-medium transition-all last:mb-0 ${
              isActive
                ? "border-[#0f8a7e] bg-[#eef8f6] text-[#0f5c66] shadow-none"
                : "border-white bg-white text-[#0f5c66] shadow-[0_2px_5px_rgba(0,0,0,0.08)] hover:border-[#00a89d] hover:text-[#00a89d]"
            }`}
          >
            <span
              className={`inline-flex h-[18px] shrink-0 -translate-y-px items-center justify-center text-[23px] font-bold leading-[18px] text-[#f0a63d] ${
                isActive ? "visible w-[16px]" : "invisible w-0"
              }`}
              aria-hidden="true"
            >
              &raquo;
            </span>
            {item.label}
          </button>
        );
      })}
    </aside>
  );
};

export default Sidebar;
